import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createRef, Component } from 'react';
import { CONSULTANT_SEARCH_SLIDE_KINDS_CANDIDATES, isUseSlide, } from '../../../../define/consts/consultant_search';
import { relationFilterByNormal } from '../../../../helpers/common/ProfessionalInformationHelper';
import { propArrayNum, propArrayShape, propBool, propFunc, } from '../../../../helpers/custom-prop-types';
import SearchFilterHead from './Common/SearchFilterHead';
import SearchFilterSubmit from './Common/SearchFilterSubmit';
import SearchFilterIndustriesBody from './SearchFilterIndustriesBody';
import SearchFilterPsSlideBody from './SearchFilterPsSlideBody';
import SearchFilterSeminarBody from './SearchFilterSeminarBody';
import SearchFilterSlideBody from './SearchFilterSlideBody';
class ConsultantSearchFilter extends Component {
    constructor(props) {
        super(props);
        this.getState = (props) => {
            const { industries, slideTypes, themes, viewSeminarThemes } = props;
            return {
                viewIndustries: industries.filter(relationFilterByNormal),
                viewSeminarThemes,
                viewSlideKinds: CONSULTANT_SEARCH_SLIDE_KINDS_CANDIDATES,
                viewSlideThemes: themes.filter(relationFilterByNormal),
                viewSlideTypes: slideTypes,
            };
        };
        this.onChangeVisibleSubmitButton = (isVisible) => {
            if (!this.sensorRef.current) {
                this.setState({ isPositionAbsoluteSubmit: isVisible });
                return;
            }
            const clientRect = this.sensorRef.current.getBoundingClientRect();
            const isPositionAbsoluteSubmit = clientRect.top < 0 ? true : isVisible;
            this.setState({ isPositionAbsoluteSubmit });
        };
        this.state = Object.assign({ isPositionAbsoluteSubmit: false }, this.getState(props));
        this.sensorRef = createRef();
    }
    shouldComponentUpdate(nextProps) {
        const { industries, slideTypes, themes, viewSeminarThemes } = this.props;
        if (slideTypes !== nextProps.slideTypes ||
            industries !== nextProps.industries ||
            themes !== nextProps.themes ||
            viewSeminarThemes !== nextProps.viewSeminarThemes) {
            this.setState(this.getState(nextProps));
            return false;
        }
        return true;
    }
    render() {
        const { inputIndustries, inputKinds, inputPsSlideTypes, inputSeminarThemes, inputThemes, inputTypes, isAdmin, isClient, isPsSlide, isSeminar, isShowFilter, isSlide, onChangeFilter, onChangeInputFilter, toggleFilter, } = this.props;
        const { isPositionAbsoluteSubmit, viewIndustries, viewSeminarThemes, viewSlideKinds, viewSlideThemes, viewSlideTypes, } = this.state;
        return (_jsxs("div", Object.assign({ className: `search_list_filter ${isShowFilter ? 'is-show' : 'is-hide'}` }, { children: [_jsx(SearchFilterHead, { isPsSlide: isPsSlide, isSeminar: isSeminar, isShowFilter: isShowFilter, isSlide: isSlide, toggleFilter: toggleFilter }), _jsxs("div", Object.assign({ className: 'search_list_filter_body_wrap' }, { children: [_jsx(SearchFilterSlideBody, { inputKinds: inputKinds, inputThemes: inputThemes, inputTypes: inputTypes, isShow: isSlide && isUseSlide(isAdmin), onChangeInputFilter: onChangeInputFilter, viewSlideKinds: viewSlideKinds, viewSlideThemes: viewSlideThemes, viewSlideTypes: viewSlideTypes }), _jsx(SearchFilterPsSlideBody, { inputPsSlideTypes: inputPsSlideTypes, isShow: isPsSlide && isClient, onChangeInputFilter: onChangeInputFilter, viewSlideTypes: viewSlideTypes }), _jsx(SearchFilterSeminarBody, { inputSeminarThemes: inputSeminarThemes, isShow: isSeminar, onChangeInputFilter: onChangeInputFilter, viewSeminarThemes: viewSeminarThemes }), _jsx(SearchFilterIndustriesBody, { inputIndustries: inputIndustries, isShow: !isSlide && !isPsSlide && !isSeminar, onChangeInputFilter: onChangeInputFilter, viewIndustries: viewIndustries })] })), _jsx(SearchFilterSubmit, { isPositionAbsoluteSubmit: isPositionAbsoluteSubmit, onChangeSubmit: onChangeFilter, onChangeVisibleSubmitButton: this.onChangeVisibleSubmitButton, sensorRef: this.sensorRef })] })));
    }
}
ConsultantSearchFilter.propTypes = {
    industries: propArrayShape().isRequired,
    inputIndustries: propArrayNum().isRequired,
    inputKinds: propArrayNum().isRequired,
    inputPsSlideTypes: propArrayNum().isRequired,
    inputSeminarThemes: propArrayNum().isRequired,
    inputThemes: propArrayNum().isRequired,
    inputTypes: propArrayNum().isRequired,
    isAdmin: propBool().isRequired,
    isClient: propBool().isRequired,
    isPsSlide: propBool().isRequired,
    isSeminar: propBool().isRequired,
    isShowFilter: propBool().isRequired,
    isSlide: propBool().isRequired,
    onChangeFilter: propFunc().isRequired,
    onChangeInputFilter: propFunc().isRequired,
    slideTypes: propArrayShape().isRequired,
    themes: propArrayShape().isRequired,
    toggleFilter: propFunc().isRequired,
    viewSeminarThemes: propArrayShape().isRequired,
};
export default ConsultantSearchFilter;
